<!-- Modal Header -->
<div class="modal-header border-0 pb-2">
  <div class="d-flex align-items-center flex-grow-1">
    <div class="create-user-icon me-3">
      <i class="bi bi-person-plus-fill"></i>
    </div>
    <div>
      <h4 class="modal-title mb-1">สร้างผู้ใช้งานใหม่</h4>
      <p class="text-muted mb-0 small">เพิ่มผู้ใช้งานประเภท User เข้าสู่ระบบ VAT</p>
    </div>
  </div>
  <button type="button" class="btn-close" aria-label="Close" (click)="dismiss()"></button>
</div>

<!-- Progress Bar -->
<div class="modal-progress">
  <div class="progress">
    <div class="progress-bar bg-success" role="progressbar" [style.width.%]="getProgressPercentage()"
      [attr.aria-valuenow]="getProgressPercentage()" aria-valuemin="0" aria-valuemax="100">
    </div>
  </div>
  <div class="progress-steps">
    <div class="step-container">
      <div *ngFor="let step of [1, 2, 3]" class="step-item">
        <div class="step-circle" [class.completed]="isStepCompleted(step)" [class.current]="isStepCurrent(step)"
          [class.clickable]="step <= currentStep" (click)="goToStep(step)">
          <i *ngIf="isStepCompleted(step)" class="bi bi-check-lg"></i>
          <i *ngIf="isStepCurrent(step)" class="{{ getStepIcon(step) }}"></i>
          <span *ngIf="!isStepCompleted(step) && !isStepCurrent(step)">{{ step }}</span>
        </div>
        <div class="step-label">{{ getStepTitle(step) }}</div>
      </div>
    </div>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body">
  <form [formGroup]="createUserForm" (ngSubmit)="onSubmit()">

    <!-- Step 1: Personal Information -->
    <div class="step-content" *ngIf="currentStep === 1">
      <div class="step-header">
        <h5 class="step-title">
          <i class="bi bi-person-circle me-2"></i>ข้อมูลส่วนตัว
        </h5>
        <p class="step-description">กรอกข้อมูลส่วนตัวของผู้ใช้งาน</p>
      </div>

      <div class="row">
        <!-- First Name -->
        <div class="col-md-6 mb-2">
          <label class="form-label">ชื่อ</label>
          <input type="text" class="form-control" formControlName="firstName" [class.is-invalid]="hasError('firstName')"
            placeholder="กรอกชื่อ">
          <div class="invalid-feedback" *ngIf="hasError('firstName')">
            {{ getErrorMessage('firstName') }}
          </div>
        </div>

        <!-- Last Name -->
        <div class="col-md-6 mb-3">
          <label class="form-label">นามสกุล</label>
          <input type="text" class="form-control" formControlName="lastName" [class.is-invalid]="hasError('lastName')"
            placeholder="กรอกนามสกุล">
          <div class="invalid-feedback" *ngIf="hasError('lastName')">
            {{ getErrorMessage('lastName') }}
          </div>
        </div>

        <!-- Email -->
        <div class="col-md-6 mb-3">
          <label class="form-label">อีเมล</label>
          <input type="email" class="form-control" formControlName="email" [class.is-invalid]="hasError('email')"
            placeholder="example@email.com">
          <div class="invalid-feedback" *ngIf="hasError('email')">
            {{ getErrorMessage('email') }}
          </div>
        </div>

        <!-- Phone Number -->
        <div class="col-md-6 mb-3">
          <label class="form-label">หมายเลขโทรศัพท์</label>
          <input type="tel" class="form-control" formControlName="phoneNumber"
            [class.is-invalid]="hasError('phoneNumber')" placeholder="0812345678" maxlength="10"
            (input)="onPhoneInput($event)">
          <div class="invalid-feedback" *ngIf="hasError('phoneNumber')">
            {{ getErrorMessage('phoneNumber') }}
          </div>
        </div>

        <!-- CID -->
        <div class="col-md-6 mb-3">
          <label class="form-label">เลขบัตรประชาชน</label>
          <input type="text" class="form-control" formControlName="cid" [class.is-invalid]="hasError('cid')"
            placeholder="1234567890123" maxlength="13" (input)="onCidInput($event)">
          <div class="invalid-feedback" *ngIf="hasError('cid')">
            {{ getErrorMessage('cid') }}
          </div>
        </div>

        <!-- Gender -->
        <div class="col-md-6 mb-3">
          <label class="form-label">เพศ</label>
          <select class="form-select" formControlName="gender" [class.is-invalid]="hasError('gender')">
            <option value="">เลือกเพศ</option>
            <option value="Male">ชาย</option>
            <option value="Female">หญิง</option>
            <option value="Other">อื่นๆ</option>
          </select>
          <div class="invalid-feedback" *ngIf="hasError('gender')">
            {{ getErrorMessage('gender') }}
          </div>
        </div>

        <!-- Date of Birth -->
        <div class="col-md-6 mb-3">
          <label class="form-label">วันเกิด</label>
          <input type="date" class="form-control" formControlName="dateOfBirth"
            [class.is-invalid]="hasError('dateOfBirth')">
          <div class="invalid-feedback" *ngIf="hasError('dateOfBirth')">
            {{ getErrorMessage('dateOfBirth') }}
          </div>
        </div>

        <!-- Registered Address Section -->
        <div class="col-12 mb-4">
          <div class="card border-primary">
            <div class="card-header bg-primary text-white">
              <h6 class="mb-0">
                <i class="bi bi-house-door me-2"></i>ที่อยู่ตามทะเบียนบ้าน
              </h6>
            </div>
            <div class="card-body">
              <div class="row">
                <!-- Registered Address Details -->
                <div class="col-md-6 mb-3">
                  <label class="form-label">บ้านเลขที่</label>
                  <input type="text" class="form-control" formControlName="registeredHouseNumber"
                    placeholder="กรอกบ้านเลขที่">
                </div>

                <div class="col-md-6 mb-3">
                  <label class="form-label">ชื่อโครงการ/ชื่ออาคาร</label>
                  <input type="text" class="form-control" formControlName="registeredProjectName"
                    placeholder="กรอกชื่อโครงการ/ชื่ออาคาร">
                </div>

                <div class="col-md-6 mb-3">
                  <label class="form-label">ซอย</label>
                  <input type="text" class="form-control" formControlName="registeredSoi" placeholder="กรอกซอย">
                </div>

                <div class="col-md-6 mb-3">
                  <label class="form-label">ถนน</label>
                  <input type="text" class="form-control" formControlName="registeredRoad" placeholder="กรอกถนน">
                </div>

                <!-- Registered Location Fields -->
                <div class="col-md-3 mb-3">
                  <label class="form-label">ตำบล/แขวง</label>
                  <input type="text" class="form-control" formControlName="registeredSubdistrict"
                    placeholder="ตำบล/แขวง">
                </div>

                <div class="col-md-3 mb-3">
                  <label class="form-label">อำเภอ/เขต</label>
                  <input type="text" class="form-control" formControlName="registeredDistrict" placeholder="อำเภอ/เขต">
                </div>

                <div class="col-md-3 mb-3">
                  <label class="form-label">จังหวัด</label>
                  <input type="text" class="form-control" formControlName="registeredProvince" placeholder="จังหวัด">
                </div>

                <div class="col-md-3 mb-3">
                  <label class="form-label">รหัสไปรษณีย์</label>
                  <input type="text" class="form-control" formControlName="registeredPostalCode"
                    [class.is-invalid]="hasError('registeredPostalCode')" placeholder="12345" maxlength="5">
                  <div class="invalid-feedback" *ngIf="hasError('registeredPostalCode')">
                    {{ getErrorMessage('registeredPostalCode') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Current Address Section -->
        <div class="col-12 mb-3">
          <div class="card border-success">
            <div class="card-header bg-success text-white d-flex justify-content-between align-items-center">
              <h6 class="mb-0">
                <i class="bi bi-geo-alt me-2"></i>ที่อยู่ปัจจุบัน
              </h6>
              <div class="form-check form-check-reverse">
                <input class="form-check-input" type="checkbox" id="sameAsRegistered" formControlName="sameAsRegistered"
                  (change)="onSameAsRegisteredChange($event)">
                <label class="form-check-label text-white" for="sameAsRegistered">
                  เหมือนที่อยู่ตามทะเบียนบ้าน
                </label>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <!-- Current Address Details -->
                <div class="col-md-6 mb-3">
                  <label class="form-label">บ้านเลขที่</label>
                  <input type="text" class="form-control" formControlName="currentHouseNumber"
                    placeholder="กรอกบ้านเลขที่">
                </div>

                <div class="col-md-6 mb-3">
                  <label class="form-label">ชื่อโครงการ/ชื่ออาคาร</label>
                  <input type="text" class="form-control" formControlName="currentProjectName"
                    placeholder="กรอกชื่อโครงการ/ชื่ออาคาร">
                </div>

                <div class="col-md-6 mb-3">
                  <label class="form-label">ซอย</label>
                  <input type="text" class="form-control" formControlName="currentSoi" placeholder="กรอกซอย">
                </div>

                <div class="col-md-6 mb-3">
                  <label class="form-label">ถนน</label>
                  <input type="text" class="form-control" formControlName="currentRoad" placeholder="กรอกถนน">
                </div>

                <!-- Current Location Fields -->
                <div class="col-md-3 mb-3">
                  <label class="form-label">ตำบล/แขวง</label>
                  <input type="text" class="form-control" formControlName="currentSubdistrict" placeholder="ตำบล/แขวง">
                </div>

                <div class="col-md-3 mb-3">
                  <label class="form-label">อำเภอ/เขต</label>
                  <input type="text" class="form-control" formControlName="currentDistrict" placeholder="อำเภอ/เขต">
                </div>

                <div class="col-md-3 mb-3">
                  <label class="form-label">จังหวัด</label>
                  <input type="text" class="form-control" formControlName="currentProvince" placeholder="จังหวัด">
                </div>

                <div class="col-md-3 mb-3">
                  <label class="form-label">รหัสไปรษณีย์</label>
                  <input type="text" class="form-control" formControlName="currentPostalCode"
                    [class.is-invalid]="hasError('currentPostalCode')" placeholder="12345" maxlength="5">
                  <div class="invalid-feedback" *ngIf="hasError('currentPostalCode')">
                    {{ getErrorMessage('currentPostalCode') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Step 2: Professional Information -->
    <div class="step-content" *ngIf="currentStep === 2">
      <div class="step-header">
        <h5 class="step-title">
          <i class="bi bi-briefcase me-2"></i>ข้อมูลการทำงาน
        </h5>
        <p class="step-description">กรอกข้อมูลการทำงานและใบอนุญาต</p>
      </div>

      <div class="row">

        <!-- VAT Member Information -->
        <div class="col-12 mb-4">
          <div class="card border-warning">
            <div class="card-header bg-warning text-dark">
              <h6 class="mb-0">
                <i class="bi bi-award me-2"></i>ข้อมูลทางวิชาชีพประเมินมูลค่าทรัพย์สิน
              </h6>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label">ประเภทสมาชิกของสมาคม VAT</label>
                  <select class="form-select" formControlName="licenseType"
                    [class.is-invalid]="hasError('vatMemberType')">
                    <option value="">เลือกประเภทสมาชิก VAT</option>
                    <option value="วิสามัญ">วิสามัญ</option>
                    <option value="สามัญ">สามัญ</option>
                    <option value="ตลอดชีพ">ตลอดชีพ</option>
                    <option value="อื่นๆ">อื่นๆ</option>
                  </select>
                  <div class="invalid-feedback" *ngIf="hasError('vatMemberType')">
                    {{ getErrorMessage('vatMemberType') }}
                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label">วันที่หมดอายุ VAT Member</label>
                  <input type="date" class="form-control" formControlName="vatMemberExpired"
                    [class.is-invalid]="hasError('vatMemberExpired')">
                  <div class="invalid-feedback" *ngIf="hasError('vatMemberExpired')">
                    {{ getErrorMessage('vatMemberExpired') }}
                  </div>
                </div>
                <div class="col-md-12 mb-3">
                  <label class="form-label">หมายเลขสมาชิก VAT (VAT ID)</label>
                  <input type="text" class="form-control" formControlName="vatMemberId"
                    [class.is-invalid]="hasError('vatMemberId')"
                    placeholder="กรอกหมายเลขสมาชิก VAT">
                  <div class="invalid-feedback" *ngIf="hasError('vatMemberId')">
                    {{ getErrorMessage('vatMemberId') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Valuer Rank Information -->
        <div class="col-12 mb-4">
          <div class="card border-info">
            <div class="card-header bg-info text-white">
              <h6 class="mb-0">
                <i class="bi bi-star me-2"></i>ผู้ประเมินค่าทรัพย์สิน (Valuer Rank)
              </h6>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label class="form-label">ผู้ประเมินหลักประเภท (Valuer Rank)**</label>
                  <select class="form-select" formControlName="valuerRank" [class.is-invalid]="hasError('valuerRank')">
                    <option value="">เลือกระดับตำแหน่ง</option>
                    <option value="วิสามัญ">วิสามัญ</option>
                    <option value="สามัญ">สามัญ</option>
                    <option value="วุฒิ">วุฒิ</option>
                    <option value="ไม่มี">ไม่มี</option>
                  </select>
                  <div class="invalid-feedback" *ngIf="hasError('valuerRank')">
                    {{ getErrorMessage('valuerRank') }}
                  </div>
                </div>
                <div class="col-md-6 mb-3">
                  <label class="form-label">วันที่หมดอายุ Valuer Rank</label>
                  <input type="date" class="form-control" formControlName="valuerRankExpired"
                    [class.is-invalid]="hasError('valuerRankExpired')">
                  <div class="invalid-feedback" *ngIf="hasError('valuerRankExpired')">
                    {{ getErrorMessage('valuerRankExpired') }}
                  </div>
                </div>
              </div>
              <div class="alert alert-warning d-flex align-items-center" role="alert">
                <i class="bi bi-exclamation-triangle me-2"></i>
                <small>ตำแหน่ง / สาขา / ตอนอย่าง / อื่นๆ - ถ้าเป็นเงินเดือนงบประมาณ ให้ใส่ตำแหน่งงบประมาณไม่ใส่ ตรง
                  ชื่อตำแหน่งงานเลย</small>
              </div>
            </div>
          </div>
        </div>

        <!-- Valuation Experience Section -->
        <div class="col-12 mb-4">
          <div class="card border-secondary">
            <div class="card-header bg-secondary text-white d-flex justify-content-between align-items-center">
              <h6 class="mb-0">
                <i class="bi bi-briefcase-fill me-2"></i>ประสบการณ์ทำงานประเมินค่าทรัพย์สิน
                (ระบุตั้งแต่เริ่มงานจนถึงปัจจุบัน)
              </h6>
              <button type="button" class="btn btn-add btn-sm" (click)="addValuationExperience()">
                <i class="bi bi-plus-circle me-1"></i>เพิ่มรายการ
              </button>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead class="table-light">
                    <tr>
                      <th style="width: 40%">ชื่อสำนักงาน/หน่วยงาน : Organization</th>
                      <th style="width: 30%">ตำแหน่งที่ปฏิบัติงาน : Position</th>
                      <th style="width: 20%">จำนวนปี : No. of Years</th>
                      <th style="width: 10%">จัดการ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let experience of valuationExperienceArray.controls; let i = index"
                      [formGroup]="$any(experience)">
                      <td>
                        <input type="text" class="form-control" formControlName="organization"
                          placeholder="กรอกชื่อสำนักงาน/หน่วยงาน">
                      </td>
                      <td>
                        <input type="text" class="form-control" formControlName="position" placeholder="กรอกตำแหน่ง">
                      </td>
                      <td>
                        <input type="number" class="form-control" formControlName="years" placeholder="ปี" min="0">
                      </td>
                      <td class="text-center">
                        <button type="button" class="btn btn-remove btn-sm" (click)="removeValuationExperience(i)"
                          [disabled]="valuationExperienceArray.length <= 1" title="ลบรายการ">
                          <span aria-hidden="true">×</span>
                          <span class="visually-hidden">ลบรายการ</span>
                        </button>
                      </td>
                    </tr>
                    <tr *ngIf="valuationExperienceArray.length === 0">
                      <td colspan="4" class="text-center text-muted py-4">
                        <i class="bi bi-inbox me-2"></i>ยังไม่มีข้อมูลประสบการณ์ กดปุ่ม "เพิ่มรายการ" เพื่อเริ่มต้น
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Education Background Section -->
        <div class="col-12 mb-4">
          <div class="card border-success">
            <div class="card-header bg-success text-white d-flex justify-content-between align-items-center">
              <h6 class="mb-0">
                <i class="bi bi-mortarboard-fill me-2"></i>ประวัติการศึกษา (ระบุตั้งแต่ระดับปริญญาตรี/ปวช.
                จนถึงการศึกษาสูงสุด)
              </h6>
              <button type="button" class="btn btn-add btn-sm" (click)="addEducationBackground()">
                <i class="bi bi-plus-circle me-1"></i>เพิ่มรายการ
              </button>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead class="table-light">
                    <tr>
                      <th style="width: 40%">ชื่อสถาบัน/วิทยาลัย/มหาวิทยาลัย : Institution</th>
                      <th style="width: 35%">คุณวุฒิ (วิชาเอก/สาขา) : Degree and Major</th>
                      <th style="width: 15%">ปีที่จบ : Year Complete</th>
                      <th style="width: 10%">จัดการ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let education of educationBackgroundArray.controls; let i = index"
                      [formGroup]="$any(education)">
                      <td>
                        <input type="text" class="form-control" formControlName="institution"
                          placeholder="กรอกชื่อสถาบัน">
                      </td>
                      <td>
                        <input type="text" class="form-control" formControlName="degree"
                          placeholder="กรอกคุณวุฒิและสาขา">
                      </td>
                      <td>
                        <input type="number" class="form-control" formControlName="yearComplete" placeholder="ปี พ.ศ."
                          min="2500" max="2600">
                      </td>
                      <td class="text-center">
                        <button type="button" class="btn btn-remove btn-sm" (click)="removeEducationBackground(i)"
                          [disabled]="educationBackgroundArray.length <= 1" title="ลบรายการ">
                          <span aria-hidden="true">×</span>
                          <span class="visually-hidden">ลบรายการ</span>
                        </button>
                      </td>
                    </tr>
                    <tr *ngIf="educationBackgroundArray.length === 0">
                      <td colspan="4" class="text-center text-muted py-4">
                        <i class="bi bi-inbox me-2"></i>ยังไม่มีข้อมูลการศึกษา กดปุ่ม "เพิ่มรายการ" เพื่อเริ่มต้น
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Professional Training Information -->
        <div class="col-12 mb-4">
          <div class="card border-info">
            <div class="card-header bg-info text-white d-flex justify-content-between align-items-center">
              <h6 class="mb-0">
                <i class="bi bi-journal-bookmark-fill me-2"></i>หัวข้ออบรม/สัมมนา ที่จัดโดย VAT และ กลต.
              </h6>
              <button type="button" class="btn btn-add btn-sm" (click)="addProfessionalTraining()">
                <i class="bi bi-plus-circle me-1"></i>เพิ่มรายการ
              </button>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-bordered table-hover">
                  <thead class="table-light">
                    <tr>
                      <th style="width: 35%">หัวข้ออบรม/สัมมนา</th>
                      <th style="width: 20%">หน่วยงานจัด</th>
                      <th style="width: 15%">CPD</th>
                      <th style="width: 20%">วันที่เข้าอบรม</th>
                      <th style="width: 10%" class="text-center">จัดการ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let training of professionalTrainingArray.controls; let i = index"
                      [formGroup]="$any(training)">
                      <td>
                        <select class="form-select" formControlName="trainingTopic"
                          [class.is-invalid]="hasError('trainingTopic')"
                          (change)="onTrainingTopicChange(i, $event)">
                          <option value="">เลือกหัวข้ออบรม/สัมมนา</option>
                          <optgroup label="หลักสูตร VAT">
                            <option value="การประเมินค่าอสังหาริมทรัพย์เบื้องต้น">การประเมินค่าอสังหาริมทรัพย์เบื้องต้น</option>
                            <option value="การประเมินค่าอสังหาริมทรัพย์ขั้นสูง">การประเมินค่าอสังหาริมทรัพย์ขั้นสูง</option>
                            <option value="การประเมินค่าเครื่องจักรและอุปกรณ์">การประเมินค่าเครื่องจักรและอุปกรณ์</option>
                            <option value="การประเมินค่าธุรกิจ">การประเมินค่าธุรกิจ</option>
                            <option value="จรรยาบรรณผู้ประเมินค่าทรัพย์สิน">จรรยาบรรณผู้ประเมินค่าทรัพย์สิน</option>
                            <option value="มาตรฐานการประเมินค่าทรัพย์สิน">มาตรฐานการประเมินค่าทรัพย์สิน</option>
                          </optgroup>
                          <optgroup label="หลักสูตร กลต.">
                            <option value="การประเมินค่าหลักทรัพย์">การประเมินค่าหลักทรัพย์</option>
                            <option value="การวิเคราะห์ทางการเงิน">การวิเคราะห์ทางการเงิน</option>
                            <option value="กฎหมายตลาดทุน">กฎหมายตลาดทุน</option>
                            <option value="การกำกับดูแลกิจการที่ดี">การกำกับดูแลกิจการที่ดี</option>
                          </optgroup>
                          <optgroup label="อื่นๆ">
                            <option value="อื่นๆ">อื่นๆ (ระบุในหมายเหตุ)</option>
                          </optgroup>
                        </select>
                        <div class="invalid-feedback" *ngIf="hasError('trainingTopic')">
                          กรุณาเลือกหัวข้ออบรม/สัมมนา
                        </div>
                      </td>
                      <td>
                        <select class="form-select" formControlName="organizer"
                          [class.is-invalid]="hasError('organizer')">
                          <option value="">เลือกหน่วยงาน</option>
                          <option value="VAT">สมาคมผู้ประเมินค่าทรัพย์สินไทย (VAT)</option>
                          <option value="กลต.">สำนักงานคณะกรรมการกำกับหลักทรัพย์และตลาดหลักทรัพย์ (กลต.)</option>
                          <option value="มหาวิทยาลัย">มหาวิทยาลัย/สถาบันการศึกษา</option>
                          <option value="หน่วยงานราชการ">หน่วยงานราชการ</option>
                          <option value="เอกชน">องค์กรเอกชน</option>
                          <option value="อื่นๆ">อื่นๆ</option>
                        </select>
                        <div class="invalid-feedback" *ngIf="hasError('organizer')">
                          กรุณาเลือกหน่วยงาน
                        </div>
                      </td>
                      <td>
                        <input type="number" class="form-control" formControlName="cpdHours"
                          placeholder="ชั่วโมง" min="0" max="100" step="0.5">
                      </td>
                      <td>
                        <input type="date" class="form-control" formControlName="trainingDate"
                          [class.is-invalid]="hasError('trainingDate')">
                        <div class="invalid-feedback" *ngIf="hasError('trainingDate')">
                          กรุณาระบุวันที่เข้าอบรม
                        </div>
                      </td>
                      <td class="text-center">
                        <button type="button" class="btn btn-remove btn-sm" (click)="removeProfessionalTraining(i)"
                          [disabled]="professionalTrainingArray.length <= 1" title="ลบรายการ">
                          <span aria-hidden="true">×</span>
                          <span class="visually-hidden">ลบรายการ</span>
                        </button>
                      </td>
                    </tr>
                    <tr *ngIf="professionalTrainingArray.length === 0">
                      <td colspan="5" class="text-center text-muted py-4">
                        <i class="bi bi-inbox me-2"></i>ยังไม่มีข้อมูลการอบรม กดปุ่ม "เพิ่มรายการ" เพื่อเริ่มต้น
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <!-- Other Professional Training Information -->
        <div class="col-12 mb-4">
          <div class="card border-warning">
            <div class="card-header bg-warning text-dark d-flex justify-content-between align-items-center">
              <h6 class="mb-0">
                <i class="bi bi-journal-text me-2"></i>หัวข้ออบรม/สัมมนา ที่จัดโดยหน่วยงานอื่น
              </h6>
              <button type="button" class="btn btn-add btn-sm" (click)="addOtherTraining()">
                <i class="bi bi-plus-circle me-1"></i>เพิ่มรายการ
              </button>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-bordered table-hover">
                  <thead class="table-light">
                    <tr>
                      <th style="width: 30%">ชื่อหลักสูตร</th>
                      <th style="width: 20%">หน่วยงานที่จัด</th>
                      <th style="width: 15%">CPD</th>
                      <th style="width: 20%">วันที่จัดหลักสูตร</th>
                      <th style="width: 10%" class="text-center">สถานะ</th>
                      <th style="width: 5%" class="text-center">จัดการ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let training of otherTrainingArray.controls; let i = index"
                      [formGroup]="$any(training)">
                      <td>
                        <input type="text" class="form-control" formControlName="courseName"
                          [class.is-invalid]="hasError('courseName')"
                          placeholder="กรอกชื่อหลักสูตร">
                        <div class="invalid-feedback" *ngIf="hasError('courseName')">
                          กรุณากรอกชื่อหลักสูตร
                        </div>
                      </td>
                      <td>
                        <input type="text" class="form-control" formControlName="organizer"
                          [class.is-invalid]="hasError('organizer')"
                          placeholder="กรอกหน่วยงานที่จัด">
                        <div class="invalid-feedback" *ngIf="hasError('organizer')">
                          กรุณากรอกหน่วยงานที่จัด
                        </div>
                      </td>
                      <td>
                        <input type="number" class="form-control" formControlName="cpdHours"
                          placeholder="ชั่วโมง" min="0" max="100" step="0.5">
                      </td>
                      <td>
                        <input type="date" class="form-control" formControlName="courseDate"
                          [class.is-invalid]="hasError('courseDate')">
                        <div class="invalid-feedback" *ngIf="hasError('courseDate')">
                          กรุณาระบุวันที่จัดหลักสูตร
                        </div>
                      </td>
                      <td class="text-center">
                        <select class="form-select form-select-sm" formControlName="status">
                          <option value="">เลือกสถานะ</option>
                          <option value="ได้รับใบรับรองแล้ว">ได้รับใบรับรองแล้ว</option>
                          <option value="หมดอายุ">หมดอายุ</option>
                          <option value="อื่นๆ">อื่นๆ</option>
                        </select>
                      </td>
                      <td class="text-center">
                        <button type="button" class="btn btn-remove btn-sm" (click)="removeOtherTraining(i)"
                          [disabled]="otherTrainingArray.length <= 1" title="ลบรายการ">
                          <span aria-hidden="true">×</span>
                          <span class="visually-hidden">ลบรายการ</span>
                        </button>
                      </td>
                    </tr>
                    <tr *ngIf="otherTrainingArray.length === 0">
                      <td colspan="6" class="text-center text-muted py-4">
                        <i class="bi bi-inbox me-2"></i>ยังไม่มีข้อมูลการอบรม กดปุ่ม "เพิ่มรายการ" เพื่อเริ่มต้น
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Step 3: Review and Submit -->
    <div class="step-content" *ngIf="currentStep === 3">
      <div class="step-header">
        <h5 class="step-title">
          <i class="bi bi-check-circle me-2"></i>ตรวจสอบและยืนยัน
        </h5>
        <p class="step-description">ตรวจสอบข้อมูลให้ถูกต้องก่อนบันทึก</p>
      </div>

      <div class="review-container">
        <!-- Personal Information Review -->
        <div class="review-section">
          <h6 class="review-section-title">
            <i class="bi bi-person-circle me-2"></i>ข้อมูลส่วนตัว
          </h6>
          <div class="review-grid">
            <div class="review-item">
              <span class="review-label">ชื่อ-นามสกุล:</span>
              <span class="review-value">{{ createUserForm.get('firstName')?.value }} {{
                createUserForm.get('lastName')?.value }}</span>
            </div>
            <div class="review-item">
              <span class="review-label">อีเมล:</span>
              <span class="review-value">{{ createUserForm.get('email')?.value }}</span>
            </div>
            <div class="review-item">
              <span class="review-label">เลขบัตรประชาชน:</span>
              <span class="review-value">{{ createUserForm.get('cid')?.value }}</span>
            </div>
            <div class="review-item">
              <span class="review-label">หมายเลขโทรศัพท์:</span>
              <span class="review-value">{{ createUserForm.get('phoneNumber')?.value }}</span>
            </div>
            <div class="review-item">
              <span class="review-label">เพศ:</span>
              <span class="review-value">
                {{
                createUserForm.get('gender')?.value === 'Male' ? 'ชาย' :
                createUserForm.get('gender')?.value === 'Female' ? 'หญิง' :
                createUserForm.get('gender')?.value || '-'
                }}
              </span>
            </div>
            <div class="review-item">
              <span class="review-label">วันเกิด:</span>
              <span class="review-value">{{ formatDateOfBirth(createUserForm.get('dateOfBirth')?.value) }}</span>
            </div>
          </div>
        </div>

        <!-- Address Information Review -->
        <div class="review-section">
          <h6 class="review-section-title">
            <i class="bi bi-house-door me-2"></i>ข้อมูลที่อยู่
          </h6>
          <div class="review-grid">
            <!-- Registered Address -->
            <div class="review-item" *ngIf="createUserForm.get('registeredHouseNumber')?.value || 
                                           createUserForm.get('registeredProjectName')?.value || 
                                           createUserForm.get('registeredSoi')?.value || 
                                           createUserForm.get('registeredRoad')?.value || 
                                           createUserForm.get('registeredSubdistrict')?.value || 
                                           createUserForm.get('registeredDistrict')?.value || 
                                           createUserForm.get('registeredProvince')?.value || 
                                           createUserForm.get('registeredPostalCode')?.value">
              <span class="review-label">ที่อยู่ตามทะเบียนบ้าน:</span>
              <span class="review-value">
                {{ getFullAddress('registered') }}
              </span>
            </div>

            <!-- Current Address -->
            <div class="review-item" *ngIf="!createUserForm.get('sameAsRegistered')?.value && 
                                           (createUserForm.get('currentHouseNumber')?.value || 
                                            createUserForm.get('currentProjectName')?.value || 
                                            createUserForm.get('currentSoi')?.value || 
                                            createUserForm.get('currentRoad')?.value || 
                                            createUserForm.get('currentSubdistrict')?.value || 
                                            createUserForm.get('currentDistrict')?.value || 
                                            createUserForm.get('currentProvince')?.value || 
                                            createUserForm.get('currentPostalCode')?.value)">
              <span class="review-label">ที่อยู่ปัจจุบัน:</span>
              <span class="review-value">
                {{ getFullAddress('current') }}
              </span>
            </div>

            <!-- Same as registered indicator -->
            <div class="review-item" *ngIf="createUserForm.get('sameAsRegistered')?.value">
              <span class="review-label">ที่อยู่ปัจจุบัน:</span>
              <span class="review-value">
                <span class="badge bg-info">
                  <i class="bi bi-check-circle me-1"></i>เหมือนที่อยู่ตามทะเบียนบ้าน
                </span>
              </span>
            </div>
          </div>
        </div>

        <!-- Professional Information Review -->
        <div class="review-section">
          <h6 class="review-section-title">
            <i class="bi bi-briefcase me-2"></i>ข้อมูลการทำงาน
          </h6>
          <div class="review-grid">
            <div class="review-item">
              <span class="review-label">หน่วยงาน/สังกัด:</span>
              <span class="review-value">{{ createUserForm.get('organization')?.value }}</span>
            </div>
            <div class="review-item">
              <span class="review-label">ประเภทใบอนุญาต:</span>
              <span class="review-value">
                {{ getLicenseName(createUserForm.get('licenseType')?.value) }}
              </span>
            </div>
            <div class="review-item">
              <span class="review-label">ระดับตำแหน่ง:</span>
              <span class="review-value">
                {{ getRankName(createUserForm.get('rankLevel')?.value) }}
              </span>
            </div>

            <!-- VAT Member Information -->
            <div class="review-item" *ngIf="createUserForm.get('vatMemberType')?.value">
              <span class="review-label">ประเภทสมาชิก VAT:</span>
              <span class="review-value">
                <span class="badge bg-warning text-dark">
                  {{ createUserForm.get('vatMemberType')?.value }}
                </span>
              </span>
            </div>
            <div class="review-item" *ngIf="createUserForm.get('vatMemberExpired')?.value">
              <span class="review-label">วันหมดอายุ VAT Member:</span>
              <span class="review-value">{{ formatDate(createUserForm.get('vatMemberExpired')?.value) }}</span>
            </div>
            <div class="review-item" *ngIf="createUserForm.get('vatMemberId')?.value">
              <span class="review-label">หมายเลขสมาชิก VAT:</span>
              <span class="review-value">{{ createUserForm.get('vatMemberId')?.value }}</span>
            </div>

            <!-- Valuer Rank Information -->
            <div class="review-item" *ngIf="createUserForm.get('valuerRank')?.value">
              <span class="review-label">วิชาชีพการประเมิน:</span>
              <span class="review-value">
                <span class="badge bg-info text-white">
                  {{ createUserForm.get('valuerRank')?.value }}
                </span>
              </span>
            </div>
            <div class="review-item" *ngIf="createUserForm.get('valuerRankExpired')?.value">
              <span class="review-label">วันหมดอายุ Valuer Rank:</span>
              <span class="review-value">{{ formatDate(createUserForm.get('valuerRankExpired')?.value) }}</span>
            </div>

            <!-- Valuation Experience Summary -->
            <div class="review-item" *ngIf="valuationExperienceArray.length > 0">
              <span class="review-label">ประสบการณ์ประเมินค่าทรัพย์สิน:</span>
              <span class="review-value">
                <span class="badge bg-secondary">
                  {{ valuationExperienceArray.length }} รายการ
                </span>
              </span>
            </div>

            <!-- Education Background Summary -->
            <div class="review-item" *ngIf="educationBackgroundArray.length > 0">
              <span class="review-label">ประวัติการศึกษา:</span>
              <span class="review-value">
                <span class="badge bg-success">
                  {{ educationBackgroundArray.length }} รายการ
                </span>
              </span>
            </div>

            <!-- Professional Training Summary -->
            <div class="review-item" *ngIf="professionalTrainingArray.length > 0">
              <span class="review-label">การเข้าอบรมสัมมนาทางวิชาชีพ (VAT/กลต.):</span>
              <span class="review-value">
                <span class="badge bg-info">
                  {{ professionalTrainingArray.length }} รายการ
                </span>
                <small class="text-muted d-block mt-1">
                  รวม CPD: {{ getTotalCPDHours() }} ชั่วโมง
                </small>
              </span>
            </div>

            <!-- Other Training Summary -->
            <div class="review-item" *ngIf="otherTrainingArray.length > 0">
              <span class="review-label">การเข้าอบรมสัมมนา (หน่วยงานอื่น):</span>
              <span class="review-value">
                <span class="badge bg-warning text-dark">
                  {{ otherTrainingArray.length }} รายการ
                </span>
                <small class="text-muted d-block mt-1">
                  รวม CPD: {{ getTotalOtherCPDHours() }} ชั่วโมง
                </small>
              </span>
            </div>

            <div class="review-item" *ngIf="createUserForm.get('vatId')?.value">
              <span class="review-label">VAT ID:</span>
              <span class="review-value">{{ createUserForm.get('vatId')?.value }}</span>
            </div>
            <div class="review-item" *ngIf="createUserForm.get('valuerId')?.value">
              <span class="review-label">Valuer ID:</span>
              <span class="review-value">{{ createUserForm.get('valuerId')?.value }}</span>
            </div>
          </div>
        </div>

        <!-- Status Review -->
        <div class="review-section">
          <h6 class="review-section-title">
            <i class="bi bi-gear me-2"></i>การตั้งค่า
          </h6>
          <div class="review-grid">
            <div class="review-item">
              <span class="review-label">สถานะเริ่มต้น:</span>
              <span class="review-value">
                <span class="badge bg-success">
                  <i class="bi bi-check-circle me-1"></i>ใช้งาน
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<!-- Modal Footer -->
<div class="modal-footer border-0 pt-0">
  <div class="d-flex justify-content-between w-100">
    <!-- Previous Button -->
    <button type="button" class="btn btn-outline-secondary" (click)="prevStep()" [disabled]="currentStep === 1">
      <i class="bi bi-arrow-left me-2"></i>ย้อนกลับ
    </button>

    <!-- Next/Submit Button -->
    <div class="d-flex gap-2">
      <button type="button" class="btn btn-secondary" (click)="close()">
        ยกเลิก
      </button>

      <button type="button" class="btn btn-success" (click)="currentStep < totalSteps ? nextStep() : onSubmit()"
        [disabled]="isSubmitting">
        <div *ngIf="isSubmitting" class="d-flex align-items-center">
          <div class="spinner-border spinner-border-sm me-2" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          กำลังบันทึก...
        </div>
        <div *ngIf="!isSubmitting">
          <span *ngIf="currentStep < totalSteps">
            ถัดไป
            <i class="bi bi-arrow-right ms-2"></i>
          </span>
          <span *ngIf="currentStep === totalSteps">
            <i class="bi bi-save me-2"></i>
            บันทึกข้อมูล
          </span>
        </div>
      </button>
    </div>
  </div>
</div>